import React from 'react'
import { Box } from '@material-ui/core'
import { Grid, Paper } from '@material-ui/core'

export default ({ classes }) => {
  return (
    <Paper>
      <Grid className={classes.importWrapp} container direction="column">
        <Grid item xs={12}>
          <Box className={classes.importBoxLoading}>
            <div style={{ position: 'relative' }}>
              <div className="lds-ellipsis">
                <div />
                <div />
                <div />
                <div />
              </div>
            </div>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  )
}
